export const SITE_NAV_AB_TEST_NAME = 'navigation-cms';
